import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logOut } from "../features/auth/authSlice";

const LogoutAdmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(logOut());
    navigate('/login'); // or whatever your login route is
  }, [dispatch, navigate]);

  return null;
};

export default LogoutAdmin;
